import * as React from "react";
import {
  Badge,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { NavLink } from "react-router-dom";

type listItemType = {
  title: string;
  icon?: JSX.Element;
  path?: string;
  /** Unread count badge (e.g. chat). */
  badgeCount?: number;
  children?: {
    title: string;
    icon: JSX.Element;
    path?: string;
    badgeCount?: number;
  }[];
};

type ListNavItemProps = {
  listItem: listItemType;
  onClick?: () => void;
};

export const ListNavItem: React.FC<ListNavItemProps> = ({
  listItem,
  onClick,
}) => {
  const listItemButtonStyle = {
    px: 1,
    borderRadius: 2,
    marginTop: 0.5,
    paddingLeft: 1,
    "&.active": {
      backgroundColor: "rgba(25, 118, 210, 0.12)",
      fontWeight: "600 !important",
    },
    "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.05)" },
  };

  if (listItem.children || !listItem.path) {
    return (
      <>
        <ListItemButton
          sx={listItemButtonStyle}
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
        >
          <ListItemIcon sx={{ minWidth: 36 }}>
            <Badge
              badgeContent={listItem.badgeCount}
              color="error"
              max={99}
              invisible={!listItem.badgeCount}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.65rem",
                  minWidth: 18,
                  height: 18,
                },
              }}
            >
              {listItem.icon}
            </Badge>
          </ListItemIcon>
          <ListItemText primary={listItem.title} />
        </ListItemButton>
      </>
    );
  }

  return (
    <>
      <ListItemButton
        component={NavLink}
        sx={listItemButtonStyle}
        to={listItem.path}
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Badge
            badgeContent={listItem.badgeCount}
            color="error"
            max={99}
            invisible={!listItem.badgeCount}
            sx={{
              "& .MuiBadge-badge": {
                fontSize: "0.65rem",
                minWidth: 18,
                height: 18,
              },
            }}
          >
            {listItem.icon}
          </Badge>
        </ListItemIcon>
        <ListItemText primary={listItem.title} />
      </ListItemButton>
    </>
  );
};
